import { render, staticRenderFns } from "./ModalValidation.vue?vue&type=template&id=2b64dd0b&scoped=true"
import script from "./ModalValidation.vue?vue&type=script&lang=js"
export * from "./ModalValidation.vue?vue&type=script&lang=js"
import style0 from "./ModalValidation.vue?vue&type=style&index=0&id=2b64dd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64dd0b",
  null
  
)

export default component.exports